<template>
<app-modal v-model="isDialogOpened"
           size="xs"
           :ok-loading="cancelScheduledClosingPending"
           :cancel-disabled="cancelScheduledClosingPending"
           @ok="prepareCancelScheduledClosing"
           @cancel="closeDialog"
>
  <template #title>{{ $t('project.signing-checklist.list.CancelScheduledSigningDialog.title') }}</template>
  <template #body>
    <v-row>
      <v-col>
        {{ $t('project.signing-checklist.list.CancelScheduledSigningDialog.text') }}
      </v-col>
    </v-row>
  </template>
</app-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import { dialogMixin } from '@/mixins/dialogMixin'
import { CANCEL_SCHEDULED_CLOSING } from '@/store/modules/signing-checklist/action_types'

export default {
  name: 'CancelScheduledSigningDialog',
  mixins: [dialogMixin],
  props: {
    mnemo: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('signingChecklist', ['cancelScheduledClosingPending']),
  },
  methods: {
    ...mapActions('signingChecklist', [CANCEL_SCHEDULED_CLOSING]),
    async prepareCancelScheduledClosing () {
      await this.CANCEL_SCHEDULED_CLOSING(this.mnemo)
    },
  },
}
</script>
